  <template >
   <div class="formPosition" v-role="'ped'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col >
          <h4 style="text-align:center;"> <span> Filtragem dos Dados - Pesquisa GLOBAL</span></h4>

<div class="text-center">
  <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  <!-- ==================================== Cadastro de recibo ========================================== -->
  <template>
  <v-row justify="center">
    <v-dialog v-model="dialogRecibo" persistent max-width="600px">
       <v-container   style="background-color:#006699; color:white;">
         <span>Cadastrar Recibo</span>
  </v-container>

      <v-card>
 <v-overlay :value="overlay2">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
        <v-card-text>
  <v-form
     ref="form2"
    v-model="valid2"
    lazy-validation
  >
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
              v-model="identificadorCliente"
              :rules="ruleRequired"
              :disabled="true"
                 label="Estudante"
              ></v-text-field>
            </v-col>
             <v-col cols="12" md="2">
              <v-text-field
              v-model="siglaBanco"
              :rules="ruleRequired"
              :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md=6>
              <v-text-field
              v-model="reciboModel"
              :rules="ruleRequired"
                label="Nº do recibo/Comprovativo"
              ></v-text-field>
            </v-col>
             <v-col cols="12" md="6">
              <v-combobox
                v-model="bancoSelected"
                :rules="ruleRequired"
                label="Selecione o banco"
                item-value="pk_banco"
                item-text="nome"
                :disabled="disabilita"
                :items="bancos"
                @change="loadContaBancaria()"
            ></v-combobox>
            </v-col>
            <v-col cols="12" md="6">
              <v-combobox
                  v-model="contaSelected"
                :rules="ruleRequired"
                :items="contasFiltered"
                :disabled="disabilita"
                item-text="numero_conta"
                label="Selecione a conta"
            ></v-combobox>
            </v-col>
            <v-col cols="12" md="12">
                <template>
                <v-menu
                    ref="menuDataPagamento"
                    v-model="menuDataPagamento"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field

                        v-model="dataPagamentoSelected"
                        :rules="[v => !!v || 'Campo obrigatorio!']"
                        label="Data de pagamento"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      max="2025-12-31"
                      min="1950-01-01"
                      v-model="datePagamento"
                      @change="saveDatePagamento"
                    ></v-date-picker>
                  </v-menu>
              </template>
            </v-col>
            <v-col cols="12" md="12">
                        <v-text-field
                          v-model="valorRecibo"
                           v-money="money"
                          :disabled="disabilita"
                          label="Valor depositado"
                       ></v-text-field>
                     </v-col>
          </v-row>
  </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn color="green" style="color:white;" :disabled="!valid2"  @click="CadastrarRecibo()">Guardar</v-btn>
           <v-btn color="red"  style="color:white;" @click="dialogRecibo = false">Cancelar</v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>
  </v-row>
  </template>

<!-- ========================================================================================================== -->
<!-- =======================================DIALOGO DE PAGAMENTO DE MENSALIDADE ================================== -->

 <v-dialog
      v-model="dialog"
      max-width="790"
    >
<v-form
     ref="form2"
    v-model="valid2"
    lazy-validation
  >
      <v-card>
        <v-card-title  style="background-color:#006699;color:white;" class="headline">
          Pagamento de Mensalidade
        </v-card-title>
      <div  v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}

      </div>
        <v-card-text>
          <v-row>
            <v-col md="6">
               <span>Mês Selecionado:</span>
            </v-col>
            <v-col md="6">
               <span style="font-weight:bold;font-size:15px;">{{(this.itemPagamento !== null)?this.itemPagamento.nome: ''}}</span>
            </v-col>
             <v-col md="6">
               <span>Preço da Mensalidade:</span>
            </v-col>
            <v-col md="6">
               <span>{{(this.multaAplicada !== null ||this.itemPagamento !== null )?utilitarios.IntegerToMoneyValue(this.itemPagamento.multa - this.multaAplicada): ''}}</span>
            </v-col>
            <v-col md="6">
               <span>Forma de Pagamento</span>
            </v-col>
             <v-col md="6">
                <v-select
                            :items="meiosPagamentos"
                            v-model="meioPagamentoSelected"
                            item-value="idMeioPagamento"
                            :rules="ruleRequired"
                            item-text="descricao"
                            label="Forma de Pagamento"
                            return-object
                            @change="SelecionaFormaPagamento()"
                        ></v-select>
            </v-col>
             <v-col md="6" v-if="showCamposRecibos">
               <span>Comprovativo de Pagamento</span>
            </v-col>
             <v-col md="6" v-if="showCamposRecibos">
                <v-combobox
                          v-model="numeroRecibo"
                          :rules="ruleRequired"
                          label="Selecione o comprovativo de pagamento"
                          item-value="num_recibo"
                          item-text="num_recibo"
                          :items="recibos"
                          hide-selected
                          return-object
                           multiple
                           @change="SelecionaRecibo()"
                           @click="initializeRecibos ()"
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar v-if="item.icone"
                            color="indigo"
                            class="headline font-weight-light white--text"
                          >
                            <v-btn  icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.num_recibo"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-combobox>
            </v-col>
            <v-col md="6" v-if="showCamposRecibos">
                  <span style="font-size:15px;">Total recibo(s):</span>
              </v-col>
               <v-col md="6" v-if="showCamposRecibos">
                  <span>{{ utilitarios.IntegerToMoneyValue(totalRecibos)}}</span>
              </v-col>
             <v-col md="6" v-if="!showCamposRecibos">
               <span>Data pagamento</span>
            </v-col>
             <v-col md="6" v-if="!showCamposRecibos">
                <template>
                         <v-menu
                              ref="menuDataPagamento"
                              v-model="menuDataPagamento"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="dataPagamentoSelected"
                                  :rules="[v => !!v || 'Campo obrigatorio!']"
                                  label="Data de pagamento"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                max="2025-12-31"
                                :disabled="!this.estudanteSelecionado.length"
                                min="1950-01-01"
                                v-model="datePagamento"
                                @change="saveDatePagamento"
                              ></v-date-picker>
                            </v-menu>
                        </template>
            </v-col>
             <v-col md="6">
               <span>Multa aplicada:</span>
            </v-col>
            <v-col md="6">
               <span>{{(this.multaAplicada !== null)?utilitarios.IntegerToMoneyValue(this.multaAplicada): ''}}</span>
            </v-col>
            <v-col md="6">
               <span>Valor a Pagar:</span>
            </v-col>
             <v-col md="6">
               <span>{{(this.itemPagamento !== null)? utilitarios.IntegerToMoneyValue(this.itemPagamento.multa): ''}}</span>
            </v-col>
             <v-col md="6"  >
               <span>Valor Entregue</span>
            </v-col>
             <v-col md="6"  >
                 <v-text-field v-if="!showValorReadyOnly" background-color="#ffff99" @keyup="CalculaTroco()" :disabled="this.showValorReadyOnly"   v-money="money" v-model="valorEntregue"></v-text-field>
                 <span style="font-size:20px;font-weight:bold;" v-if="showValorReadyOnly">{{utilitarios.IntegerToMoneyValue(this.valorEntregue)}}</span>
            </v-col>
             <v-col cols="12" sm="6" md="6">
                <span>Troco</span>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <span>{{ utilitarios.IntegerToMoneyValue(troco)}}</span>
              </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="close()"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
            :disabled="!valid"
          >
          Finalizar Pagamento
          </v-btn>
        </v-card-actions>
      </v-card>
</v-form>
    </v-dialog>

<!-- ===========================================FIM DO DIALOGO ===================================================== -->

 <v-container fluid>
    <v-row align="center">

      <v-col class="d-flex" cols="12" sm="6" md="6">
          <v-autocomplete
            v-model="estudantePesquisa"
            :items="estudantesLista"
            :loading="isLoading_"
            :search-input.sync="search"
            color="primary"
            item-text="nome"
            item-value="nome"
            label="Pesquise utilizando o número de Bi ou Matrícula"
            placeholder="Digite o nome do estudante"
            prepend-icon="mdi-database-search"
            return-object
            @change="PesquisarEstudante()"
        ></v-autocomplete>

      </v-col>
     <v-col class="d-flex" cols="4" sm="6" md="6" >
     <v-row>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Nome:{{(this.estudanteSelecionado.length)?(this.estudanteSelecionado[0].nome):''}}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip  style="margin:4px;">Matricula:{{(this.estudanteSelecionado.length)?(this.estudanteSelecionado[0].numero_matricula):''}}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip  style="margin:4px;">Curso:{{(this.estudanteSelecionado.length)?(this.estudanteSelecionado[0].curso):''}}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip  style="margin:4px;">Clase:{{(this.estudanteSelecionado.length)?(this.estudanteSelecionado[0].classe_descricao):''}}</v-chip>
     </v-col>
    </v-row>
      </v-col>
    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
        <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>
  <v-col md="6">
    <v-card-text>
      <strong><v-chip color="green" style="margin:4px;color:white">Pagamentos Efectuados</v-chip></strong>
    </v-card-text>
    <hr>
    <v-row>
     <v-data-table
            :headers="headers_"
            :items="this.pagamentosFeitos"
          >

      </v-data-table>

    </v-row>

    <hr>
  </v-col>
  <v-col md="6">
    <v-card-text>
      <strong><v-chip color="pink" style="margin:4px;color:white"> Mensalidades não pagas</v-chip></strong>
    </v-card-text>
    <hr>

    <v-data-table
            :headers="headers"
            :items="this.mesesAPagar"
          >
  <template v-slot:item.Pagar="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-if="mesesAPagar.indexOf(item)===0" color="green" v-bind="attrs" v-on="on" style="color:white;" @click="AbrirPagamento(item)">payments</v-icon>
          </template>
          <span>Clique aqui para efectuar o pagamento da Mensalidade</span>
        </v-tooltip>
              </template>
      </v-data-table>

  </v-col>

</v-row>
  </v-card>

  </v-container>

  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
import utilitarios, { IntegerToMoneyValue } from '../../plugins/utilitarios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
const ls = require('local-storage')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    price: 0,
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    valorEntregue: 0,
    select1: null,
    pesquisa_parameto: null,
    estudantePesquisa: null,
    dataPagamentoSelected: null,
    troco: 0,
    precoPropinaFiltered: [],
    numeroRecibo: [],
    recibos: [],
    estudante_dados: [],
    estudantesLista: [],
    meioPagamentoSelected: null,
    multasFiltered: [],
    meiosPagamentos: [],
    itemPagamento: null,
    itemPagamentoSelected: null,
    showValorReadyOnly: false,
    identificadorCliente: null,
    utilitarios: utilitarios,
    multaAplicada: null,
    precosPropina: [],
    estudanteSelecionado: [],
    pagamentosFeitos: [],
    precoMulta: [],
    bancoSelected: null,
    contaSelected: null,
    contasFiltered: null,
    meses: [],
    mesesPago: [],
    bancos: [],
    contas: [],
    precoPropina: [],
    estudantes: [],
    mesesAPagar: [],
    dialogRecibo: false,
    overlay: false,
    overlay2: false,
    showCamposRecibos: false,
    idMatricula: null,
    msg_pesquisa: true,
    isLoading_: false,
    search: '',
    pesquisa: '',
    estudante: true,
    valid: false,
    valid2: true,
    dialog: false,
    progresso: false,
    Pessoas: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers_: [
      { text: '', value: 'indice' },
      { text: 'Emolumento', value: 'descricao' },
      { text: 'Mês Pago', value: 'mes' },
      { text: 'Data pagamento', value: 'dataPagamento' },
      { text: 'Tot. Ilíquido', value: 'valorAPagar' },
      { text: 'Pago', value: 'valorPago' }
    ],
    headers: [
      { text: 'Mês', value: 'nome' },
      { text: 'Prazo de Multa 1', value: 'data1' },
      { text: 'Prazo de Multa 2', value: 'data2' },
      { text: 'Prazo de Multa 3', value: 'data3' },
      { text: 'Prazo de Multa 3', value: 'data3' },
      { text: 'Action', value: 'Pagar' }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    Integrado () {
      return ls.get('integrado') === '1'
    },
    totalRecibos () {
      let valor = 0
      this.numeroRecibo.forEach(element => {
        valor += (element.pk_recibo === -1) ? 0 : parseFloat(element.valor)
      })
      if (this.numeroRecibo.length) {
        if (valor < this.precoTotal) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.result = 'O valor do recibo é inferior ao total a pagar'
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.cor = 'red'
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.showResult = true
        } else {
        }
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return valor
    }
  },
  watch: {
    search (val) {
      // Items have already been loaded
    // this.estudantes = []
      // console.log('passouuuuuu' + this.estudantes.length)
      if (val.length > 2) {
      // Items have already been requested
        if (!this.estudantes.filter(t => t.nome.includes(val)).length) {
          this.estudantes = []
        }
        if (!this.Integrado) { return this.InitializarEstudanteLocal(val) }
        return this.InitializarEstudante(val)
      }
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.meses = ls.get('meses')
    this.initializePrecoPropina()
    this.initializeprecoMulta()
    this.initializeMeiosPagamento()
    this.initializeBanco()
    this.initializeConcaBanco()
    this.dataPagamentoSelected = utilitarios.ObterDataActural()
  },
  methods: {

    async  Pesquisar () {
      try {
        this.progresso = true
        this.estudante_dados = await axios
          .get('/PesquisaGlobal/' + this.pesquisa)
          .then(res => res.data)
        this.progresso = false
        if (!this.estudante_dados.length) { this.msg_pesquisa = false } else { this.msg_pesquisa = true }
      } catch (error) {
        this.progresso = false
      }
    },
    async  PesquisarEstudante () {
      if (!this.Integrado) {
        this.PesquisaLocal() // De forma Local - na base de dados local
      } else {
        this.PesquisaGlobal() // De forma Global - na base de dados Global
      }
    },
    async initializeRecibos () {
      if (this.estudantePesquisa !== null) {
        try {
          this.isLoading = true
          this.recibos = await axios
            .get('/recibosFindAll/' + this.estudantePesquisa.pk_estudante)
            .then(res => res.data)
          let add = { num_recibo: 'Novo recibo', icone: true, pk_recibo: -1 }
          this.recibos.push(add)

          this.isLoading = false
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    async initializeBanco () {
      try {
        this.isLoading = true
        this.bancos = await axios
          .get('/bancoFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeConcaBanco () {
      try {
        this.isLoading = true
        this.contas = await axios
          .get('/conta-bancariaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    loadContaBancaria () {
      if (this.bancoSelected !== '') {
        this.contasFiltered = this.contas.filter(c => c.fk_banco === this.bancoSelected.pk_banco)
        this.siglaBanco = this.bancoSelected.sigla
      }
    },

    SelecionaRecibo () {
      if (this.numeroRecibo.filter(m => m.pk_recibo === -1).length && this.numeroRecibo.length <= 1) {
        this.dialogRecibo = true
        this.numeroRecibo = []
        this.identificadorCliente = this.estudantePesquisa.nome
      } else {
        if (this.numeroRecibo.filter(m => m.pk_recibo === -1).length && this.numeroRecibo.length > 1) {
          let item = this.numeroRecibo.filter(m => m.pk_recibo === -1)
          let index = this.numeroRecibo.indexOf(item[0])
          this.numeroRecibo.splice(index, 1)
        }
        if (this.numeroRecibo.length > 1) { this.reciboMaiorData = utilitarios.ObterReciboComMarioValor(this.numeroRecibo) } else { this.reciboMaiorData = this.numeroRecibo }
      }
      this.valorEntregue = this.totalRecibos
      this.CalculaTroco()
    },

    async PesquisaLocal () {
      try {
        this.overlay = true
        let msg = await axios
          .post('/PesquisaEstudanteFin', this.estudantePesquisa)
          .then(res => res.data)
        if (msg.length) {
          this.estudanteResult = msg
          this.estudanteSelecionado = msg
          this.PesquisarStatusPagamento(msg[0]) // --Pesquisa pelos pagamentos de proprina feitos por este estudante
          this.PesquisarPrecoPropina(msg[0])
          this.multasFiltered = this.multas.filter(m => m.fk_classe === msg[0].pk_classe)
          this.initializeRecibos()
        } else {
          this.cor = 'red'
          this.result = 'Estudante não encontrado'
          this.showResult = true
        }
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeMeiosPagamento () {
      try {
        this.isLoading = true
        this.meiosPagamentos = await axios
          .get('/meiosPagamento')
          .then(res => res.data)
        if (this.meiosPagamentos.length) { this.meioPagamentoSelected = this.meiosPagamentos[0]; this.NumeroDocumento(); this.showCamposRecibos = false }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async PesquisaGlobal () {
      try {
        this.overlay = true
        let msg = await axios
          .post('/PesquisaEstudantePed', this.estudantePesquisa)
          .then(res => res.data)
        if (msg.length) {
          this.estudanteResult = msg
          this.estudanteSelecionado = msg
          this.PesquisarPrecoPropina(msg[0])
          this.PesquisarStatusPagamento(msg[0]) // --Pesquisa pelos pagamentos de proprina feitos por este estudante
          this.PesquisarPagamentosEstudante(msg[0]) // Pesquisa pelo historico de pagamento do estudante
          this.FiltraMulta(msg[0])
          this.initializeRecibos()
          // this.multasFiltered = this.multas.filter(m => m.fk_classe === msg[0].pk_classe)
          // this.cursosFiltrado = this.cursos.filter(c => c.idCurso === msg[0].idCurso)
        } else {
          this.cor = 'red'
          this.result = 'Estudante não encontrado'
          this.showResult = true
        }
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    SelecionaFormaPagamento () {
      if (this.meioPagamentoSelected.idMeioPagamento === 1) { // verifica qual é a forma de pagamento - No caso - Dinheiro
        this.showCamposRecibos = false
        this.showValorReadyOnly = false
        this.numeroRecibo = []
        this.valorEntregue = 0
        this.dataPagamentoSelected = utilitarios.ObterDataActural()
      } else {
        this.showCamposRecibos = true
        this.showValorReadyOnly = true
        this.valorEntregue = 0
      }
    },

    FiltraMulta (estudante) {
      this.multasFiltered = this.precoMulta.filter(m => parseInt(m.fk_curso) === parseInt(estudante.idCurso) && parseInt(m.idanoacademico) === parseInt(estudante.fk_classe))
      this.precoPropinaFiltered = this.precosPropina.filter(p => parseInt(p.idCurso) === parseInt(estudante.idCurso) && parseInt(p.fkClasse) === parseInt(estudante.fk_classe))
    },

    async PesquisarStatusPagamento (estudante) {
      try {
        let params = {
          estudante: estudante.pk_estudante,
          anolectivo: estudante.ano_lectivo
        }
        this.isLoading = true
        let result = await axios
          .post('/estudanteStatusPagamento', params)
          .then(res => res.data)
        if (result.length) {
          this.mesesAPagar = utilitarios.removeArrayFromOhter(this.meses, result)
          // this.mesesAPagar = utilitarios.AdicionarMultaAOArrayCurrentDate(this.mesesAPagar, this.precoPropina)
        } else {
          this.mesesAPagar = ls.get('meses')
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    AbrirPagamento (item) {
    /*  this.dialog = true
      this.itemPagamentoSelected = item
      this.itemPagamento = utilitarios.AdicionarMultaAOObjecto(item, this.multasFiltered, this.dataPagamentoSelected)
      let valorMulta = 0
      if (this.precoPropinaFiltered.length) {
        valorMulta = (this.itemPagamento.tipoMulta === 'Percentual') ? utilitarios.ObterValorDaPercentagem(this.precoPropinaFiltered[0].preco, this.itemPagamento.multa) : (this.precoPropinaFiltered[0].preco + this.itemPagamento.multa)
        this.multaAplicada = valorMulta
        this.itemPagamento.multa = (this.itemPagamento.tipoMulta === 'Percentual') ? utilitarios.ObterValorDaPercentagem(this.precoPropinaFiltered[0].preco, this.itemPagamento.multa) + this.precoPropinaFiltered[0].preco : (this.precoPropinaFiltered[0].preco + this.itemPagamento.multa)
      } else { // Preço de propina não encontrado - emitir uma lerta

      } */
      this.$store.state.estudante = this.estudanteResult
      this.$router.push('pagamento')
    },

    async PesquisarPrecoPropina (estudante) {
      try {
        this.isLoading = true
        let result = await axios
          .post('/ObterPrecoPropina', estudante)
          .then(res => res.data)
        this.precoPropina = result
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async PesquisarPagamentosEstudante (estudante) {
      try {
        let params = {
          estudante: estudante.pk_estudante
        }
        this.isLoading = true
        this.pagamentosFeitos = await axios
          .post('/estudantePagamentosFeitos', params)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeprecoMulta () {
      try {
        this.isLoading = true
        this.precoMulta = await axios
          .get('/precoMultas')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializePrecoPropina () {
      try {
        this.isLoading = true
        this.precosPropina = await axios
          .get('/precoPropinasFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async InitializarEstudante (searchDB) {
      this.isLoading = true
      this.isLoading_ = true
      if (searchDB) {
        var payload = '{ "find" : "' + searchDB + '" }'
      } else {
        payload = '{ "find":"all" }'
      }
      try {
        // this.isLoading = true
        this.estudantesLista = await axios
          .get('/PesquisaEstudanteGlobal/' + payload)
          .then(res => res.data)
        this.isLoading = false
        this.isLoading_ = false
      } catch (error) {
        this.isLoading = false
        this.isLoading_ = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    saveDatePagamento (datePagamento) {
      this.$refs.menuDataPagamento.save(datePagamento)
      this.dataPagamentoSelected = datePagamento
      this.CalculaMulta()
    },

    CalculaMulta () {
      this.dialog = true
      this.itemPagamento = this.itemPagamentoSelected
      this.itemPagamento.multa = 0
      this.itemPagamento = utilitarios.AdicionarMultaAOObjecto(this.itemPagamentoSelected, this.multasFiltered, this.dataPagamentoSelected)
      let valorMulta = 0
      if (this.precoPropinaFiltered.length) {
        valorMulta = (this.itemPagamento.tipoMulta === 'Percentual') ? utilitarios.ObterValorDaPercentagem(this.precoPropinaFiltered[0].preco, this.itemPagamento.multa) : (this.precoPropinaFiltered[0].preco + this.itemPagamento.multa)
        this.multaAplicada = valorMulta
        this.itemPagamento.multa = (this.itemPagamento.tipoMulta === 'Percentual') ? utilitarios.ObterValorDaPercentagem(this.precoPropinaFiltered[0].preco, this.itemPagamento.multa) + this.precoPropinaFiltered[0].preco : (this.precoPropinaFiltered[0].preco + this.itemPagamento.multa)
      } else { // Preço de propina não encontrado - emitir uma lerta

      }
    },

    CalculaTroco () {
      let troco = (utilitarios.MoneyValueToInteger(this.valorEntregue) - this.itemPagamento.multa)
      if (troco < 0) {
        this.valid = false
        this.troco = 0
        this.text = 'O valor Entregue é insuficiênte ao total a pagar'
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } else {
        this.valid = true
        this.troco = troco
      }
    },

    close () {
      this.dialog = false
      this.$refs.form2.reset()
      this.valorEntregue = 0
      this.CalculaTroco()
    },

    async  FinalizarPagamento () {
    }

  }

}

</script>
